import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { GeoChart1CompareRenderer } from '../../components';
import {
  DefaultReportChartThemeFont,
  extendDefaultChartValidationSchema,
  GRAPHIC_VISUAL_MAP_DEFAULT_RANGE_COLORS,
} from '../default-chart.config';
import { GeoChart1Measures } from './geo-chart1.measures';

export const GeoChart1DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: extendDefaultChartValidationSchema({
    withCompareCriteria: false,
  }),
  measures: GeoChart1Measures,
  compareRendererComponent: GeoChart1CompareRenderer,
  compareHeader: {
    labelKey: 'page-reports:compare',
    showIcon: false,
  },
  measureHeader: {
    labelKey: 'page-reports:measurement',
    showIcon: false,
  },
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    transactionalDate: {
      active: false,
    },
    sortResults: {
      limit: 0,
      order: null,
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: false,
      alignment: 'horizontal',
      displayFormat: 'auto',
      roundingMethod: 'default',
    },
    visualMap: {
      active: false,
      inRange: {
        defaultColor: 'THEME_2',
        customize: false,
        color: GRAPHIC_VISUAL_MAP_DEFAULT_RANGE_COLORS.THEME_2,
      },
    },
  },
};
